/**
 * Maps PageType string values to MUI icon names (keys in iconMapping).
 */
export const pageTypeIconMap: Record<string, string> = {
  Unknown: 'question_answer',
  Generic: 'description',
  Department: 'business',
  FAQ: 'quiz',
  'Contact Directory': 'group',
  'Calendar Event': 'calendar_today',
  'News/Press Release': 'campaign',
  'Meeting Document': 'note',
  'Public Comment': 'comment',
  'Job Posting': 'work',
  'Report Publication': 'bar_chart',
  Procurement: 'shopping_cart',
}
